<template>
  <div class="invoices-view">
    <div class="animated fadeIn fast">
      <div class="viewBilling">
        <main class="contenedor">
          <div class="px-4 d-inline" v-if="currentUser.role_id == 1">
            <Tabs
              :tabs="tabs"
              @change="changeTab($event)"
              :tabSelected="tabSelected"
            />
          </div>
          <LoadingSpinner v-if="loading" />
          <div class="card mt-3 p-4" v-if="!loading">
            <div>
              <table class="table table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">{{ $t("lang.column.invoicenumber") }}</th>
                    <th scope="col">{{ $t("lang.column.company") }}</th>
                    <th scope="col">{{ $t("lang.column.paymentmethod") }}</th>
                    <th scope="col">{{ $t("lang.column.idtransaction") }}</th>
                    <th scope="col">{{ $t("lang.column.amount") }} H.T</th>
                    <th scope="col">VAT (20%)</th>
                    <th scope="col">Total TTC</th>
                    <th scope="col" v-if="currentUser.role_id == 1">Actions</th>
                  </tr>
                </thead>
                <tbody v-if="invoices.length > 0">
                  <tr v-for="(invoice, key) in invoices" :key="key">
                    <td scope="row">
                      {{ invoice.id | invoiceFormat }}
                      <div class="small">
                        {{ invoice.date | moment("DD/MM/YYYY") }}
                      </div>
                      <div
                        class="badge"
                        :class="statusPayment(invoice.payment_status_id)"
                      >
                        {{ $t("lang.payment." + invoice.payment_status) }}
                      </div>
                    </td>
                    <td>
                      {{ invoice.client_name }}
                      <span class="small ml-2">({{ invoice.client_id }}) </span>
                      <div class="small" v-if="invoice.legal_representative">
                        {{ $t("lang.column.legalrepresentative") }}
                      </div>
                      <div class="small" v-if="invoice.legal_representative">
                        {{ invoice.legal_representative }}
                      </div>
                    </td>
                    <td>
                      {{ invoice.payment_method }}
                    </td>
                    <td>
                      {{ invoice.ingenico_pay_id }}
                      <div>
                        {{ invoice.description }}
                        <button
                          class="
                            align-self-end
                            btn btn-sm btn-theme-bg-transparent
                            ml-2
                          "
                          @click="downloadPDF(invoice)"
                        >
                          <i class="icon-download ml-2"></i>
                        </button>
                      </div>
                    </td>

                    <td>
                      {{
                        (
                          (invoice.amount -
                            invoice.discount_amount -
                            invoice.discount_previous_payment) *
                          1
                        ).toFixed(2)
                      }}
                      €
                    </td>
                    <td>
                      {{
                        (
                          (invoice.amount_with_vat -
                            invoice.amount -
                            ("-" + invoice.discount_amount)) *
                          1
                        ).toFixed(2)
                      }}
                      €
                    </td>
                    <td>{{ invoice.amount_with_vat }} €</td>
                    <td v-if="currentUser.role_id == 1">
                      <button
                        @click="changePaymentStatus(invoice.id, 2)"
                        class="btn btn-success"
                        title="Collect"
                        :disabled="
                          !(
                            ['3'].includes(invoice.payment_status_id) &&
                            invoice.has_payment_method == '1'
                          )
                        "
                      >
                        <i class="icon-dollar"></i>
                      </button>
                      <button
                        @click="changePaymentStatus(invoice.id, 6)"
                        class="btn btn-danger ml-2"
                        title="Cancel"
                        :disabled="
                          !['1', '3', '4'].includes(invoice.payment_status_id)
                        "
                      >
                        <i class="icon-remove"></i>
                      </button>
                      <button
                        @click="changePaymentStatus(invoice.id, 4)"
                        class="btn btn-secondary ml-2"
                        title="Exonerate"
                        :disabled="
                          !['1', '3', '6'].includes(invoice.payment_status_id)
                        "
                      >
                        <i class="icon-ban"></i>
                      </button>
                      <button
                        @click="changePaymentStatus(invoice.id, 5)"
                        class="btn btn-primary ml-2"
                        title="Paid manually"
                        :disabled="
                          !['1', '3','4', '6'].includes(invoice.payment_status_id)
                        "
                      >
                        <i class="icon-thumbs-up"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="no-results-row">
                    <td colspan="4">
                      <span class="font-weight-bold ft-1-5 text-center">{{
                        $t("lang.label.therearenoinvoicesatthemoment")
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <button
                class="
                  btn
                  cursor-pointer
                  font-weight-bolder
                  btn-sm btn-outline-dark
                "
                @click="descargarCsv"
              >
                {{ $t("lang.button.downloadalldata") }}
              </button>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { billingsService, adminService } from "@/_services";
import { pdfInvoiceMixin, statusBadgeMixin } from "@/_mixins/";
import Tabs from "@/components/Common/Tabs.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: true,
      invoices: [],
      unparsedResults: null,
      tabSelected: 1,
      tabs: {
        1: {
          id: 1,
          name: this.$t("lang.label.all"),
          paymentStatusId: 0,
        },
        2: {
          id: 2,
          name: this.$t("lang.payment.Paid"),
          paymentStatusId: 2,
          icon: "icon-dollar",
        },
        3: {
          id: 3,
          name: this.$t("lang.payment.Declined"),
          paymentStatusId: 3,
          icon: "icon-frown-o",
        },
        4: {
          id: 4,
          name: this.$t("lang.payment.Exonerated"),
          paymentStatusId: 4,
          icon: "icon-star-o",
        },
        5: {
          id: 5,
          name: this.$t("lang.payment.Canceled"),
          paymentStatusId: 6,
          icon: "icon-remove",
        },
        6: {
          id: 6,
          name: this.$t("lang.payment.Pending"),
          paymentStatusId: 1,
          icon: "icon-watch_later",
        },
      },
    };
  },
  components: {
    LoadingSpinner,
    Tabs,
  },
  mixins: [pdfInvoiceMixin, statusBadgeMixin],
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
  },
  created() {
    this.getData();
  },
  watch: {
    unparsedResults(current) {},
  },
  methods: {
    changePaymentStatus(paymentId, paymentStatusId) {
      adminService
        .changePaymentStatus(paymentId, paymentStatusId)
        .then((result) => {
          this.getData();
        })
        .then((result) => (this.loading = false));
    },
    changeTab(id) {
      if (!this.loading) {
        this.tabSelected = id;
        this.getData();
      }
    },
    descargarCsv() {
      let datosExportar = [];
      for (let i = 0; i < this.invoices.length; i++) {
        datosExportar.push({
          "Invoice N°": this.invoices[i].id,
          Date: this.invoices[i].date,
          "Client ID": this.invoices[i].client_id,
          "Profile Name": this.invoices[i].profile_name,
          "Legal representative": this.invoices[i].legal_representative,
          "Id Transaction": this.invoices[i].ingenico_pay_id,
          "Card Number": this.invoices[i].description,
          Status: this.invoices[i].payment_status,
          "Amount H.T": this.invoices[i].amount + " €",
          "VAT (20%)": (this.invoices[i].amount * 0.2).toFixed(2) + " €",
          "Total TTC": this.invoices[i].amount_with_vat + " €",
        });
      }

      this.unparsedResults = this.$papa.unparse(datosExportar, {
        delimiter: ";",
      });
      this.$papa.download(this.unparsedResults, "title");
    },
    getData() {
      this.getInvoices();
    },
    getInvoices() {
      this.loading = true;
      let paymentStatusId = this.tabs[this.tabSelected].paymentStatusId;
      billingsService
        .getInvoices(paymentStatusId)
        .then((result) => {
          this.invoices = result;
        })
        .then((result) => (this.loading = false));
    },
  },
};
</script>
